export enum CycleTestState {
  IDLE = 'idle',
  MOVING_TO_POS0 = 'moving_to_pos0',
  WAITING_AT_POS0 = 'waiting_at_pos0',
  MOVING_TO_POS1 = 'moving_to_pos1',
  WAITING_AT_POS1 = 'waiting_at_pos1',
  PAUSED = 'paused',
  COMPLETED = 'completed',
  ERROR = 'error'
}

export interface CycleTestConfig {
  position0: number
  position1: number
  cycleCount: number
  timeoutSeconds: number
  stagnationSeconds: number
  dwellSeconds: number
}

export interface CycleLogEntry {
  CycleIteration: number
  completedAt: Date
}

export const DEFAULT_CONFIG: CycleTestConfig = {
  position0: 0,
  position1: 0,
  cycleCount: 1,
  timeoutSeconds: 60,
  stagnationSeconds: 7,
  dwellSeconds: 4
}
export const POLL_INTERVAL_MS = 50
